/**
 * Setup Helper card (A17) — first-run activation. Deterministic; works without
 * any AI key. Shows progress + the next step with a deep-link, and disappears
 * once setup is complete (clean dashboard). For OWNER/HR.
 */
import { Link } from 'react-router-dom';
import { CheckCircle2, Circle, ChevronRight } from 'lucide-react';
import { useSetupChecklist } from '../hooks';

export function SetupCard() {
  const { data } = useSetupChecklist();
  if (!data || data.complete) return null; // hide when done

  return (
    <section className="card p-4 space-y-3">
      <div className="flex items-center gap-2">
        <h2 className="font-display font-semibold">เริ่มต้นใช้งาน</h2>
        <span className="ml-auto text-sm font-medium text-brand-700">ตั้งค่าครบ {data.pct}%</span>
      </div>

      <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div className="h-full bg-brand-gradient" style={{ width: `${data.pct}%` }} />
      </div>

      <ul className="space-y-1.5">
        {data.items.map((it) => (
          <li key={it.key}>
            {it.done ? (
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <CheckCircle2 className="w-4 h-4 text-brand-500" />
                <span className="line-through">{it.label}</span>
              </div>
            ) : (
              <Link to={it.route} className="flex items-center gap-2 text-sm hover:text-brand-700">
                <Circle className="w-4 h-4 text-gray-300" />
                <span className="flex-1">{it.label}</span>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </Link>
            )}
          </li>
        ))}
      </ul>

      {data.nextStep && (
        <Link to="/owner/setup" className="btn-cta w-full justify-center flex">
          เปิดตัวช่วยตั้งค่า — ขั้นต่อไป: {data.nextStep.label}
        </Link>
      )}
    </section>
  );
}
